// @ts-nocheck

import React from 'react';
import cn from 'classnames';

import { CLOUDFRONT_LOGOS_ROOT_URL } from '@shared/config/constants/app';
import { LanguageSelector } from '@shared/ui/language-selector';
import { Container, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import styles from '../styles/HeaderS.module.css';

const logoS = `${CLOUDFRONT_LOGOS_ROOT_URL}/vuz/vuzvip_white.png`;

const HeaderS = ({
  isCC = false,
  isRaffle = false,
  formStartRef = null,
  howItWorksRef = null,
  isV4 = false,
  hideMonths = false,
  languageConfig = {},
  isUnsubPage = false,
}) => {
  const { t } = useTranslation();

  const { showLanguageSelector = true } = languageConfig;

  const handleScrollToHowItWorks = () => {
    if (howItWorksRef && howItWorksRef.current) {
      howItWorksRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className={cn('landing-section-1', isV4 && styles.navbarShadow)}>
      <Container className="container-sm py-3 sticky-header force-ltr">
        <Row
          className={styles.rowAlignEnd}
          style={{ justifyContent: `${isRaffle ? 'space-between' : ''}` }}
        >
          <Col className={cn(isRaffle && 'col-5')}>
            <div className="text-center">
              {isRaffle && (
                <img
                  src={logoS}
                  className={cn('img-fluid', 'mt-2', styles.pluslogo)}
                  alt="360VUZ Logo"
                />
              )}
              {!isRaffle && (
                <Link to={`${isV4 ? (hideMonths ? '/cc/6' : '/cc/4') : '/cc/3'}`}>
                  <img
                    src={logoS}
                    className={cn('img-fluid', 'mt-2', styles.pluslogo)}
                    alt="360VUZ Logo"
                  />
                </Link>
              )}
            </div>
          </Col>
          {!isRaffle && (
            <Col>
              {isV4 ? (
                <Link
                  to={hideMonths ? '/cc/6/subscribe' : '/cc/4/subscribe'}
                  className={cn(styles.joinNowBtn, styles.joinNowBtnLink)}
                >
                  {t('start_trial')}
                </Link>
              ) : (
                !isCC && (
                  <button
                    className={cn(styles.joinNowBtn, 'glow-buttonX')}
                    onClick={handleScrollToHowItWorks}
                  >
                    {t('start_trial')}
                  </button>
                )
              )}
            </Col>
          )}
          <Col className={styles.contentWidth}>
            {showLanguageSelector ? (
              <LanguageSelector languageConfig={languageConfig} isUnsubPage={isUnsubPage} />
            ) : null}
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export { HeaderS };
